import { PagedGridEffects } from './paged-grid';

export * from './state';

export const pagedGridSharedEffects = [PagedGridEffects];
